import React from 'react'

const Radio = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="1" width="15" height="15" rx="7.5" stroke="#71717A" />
    </svg>
  ),
)
Radio.displayName = 'Radio'

export { Radio }
